import { restartableTask } from 'ember-concurrency';
import ProtectedController from 'volta/controllers/protected-controller';
import JsonApiInfinityModel from 'volta/models/jsonapi-infinity-model';
import type { TError } from 'volta/utils/error-utils';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import { inject as service } from '@ember/service';
import type InfinityService from 'ember-infinity/services/infinity';
import type { IResourceName } from 'volta/models/base-model';
import type StoreService from 'volta/services/store';
import type { IJsonApiQuery } from 'volta/utils/api/jsonapi-types';

export default class ResourceController extends ProtectedController {
  // Services
  // ~~~~~

  @service declare store: StoreService;
  @service declare infinity: InfinityService;

  // Properties
  // ~~~~~

  declare resourceName: IResourceName;
  infiniteScroll: boolean = false;

  // Helper functions
  // ~~~~~

  // Here we use a task on the controller so the result is persisted between pages transitions
  resourceCollectionTask = restartableTask(async (apiQuery = {}) => {
    const query = this.formatApiQuery(apiQuery);
    try {

      return this.infiniteScroll
        ? await this.infinity.model(this.resourceName.singular, query, JsonApiInfinityModel)
        // @ts-ignore
        : await this.store.query<any>(this.resourceName.singular, query);
    } catch (error) {
      return defaultErrorHandler(error as TError);
    }
  });

  formatApiQuery(apiQuery: IJsonApiQuery) {
    return apiQuery;
  }
}
